import { render } from "./SendMediaPics.vue?vue&type=template&id=3af53e8a&scoped=true"
import script from "./SendMediaPics.vue?vue&type=script&lang=js"
export * from "./SendMediaPics.vue?vue&type=script&lang=js"

import "./SendMediaPics.vue?vue&type=style&index=0&id=3af53e8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3af53e8a"

export default script